export default __webpack_public_path__ + "static/media/bounding-boxes.bbd368ce.gif";